/* Custom high-contrast SVG icons for SOS tiles.
   Designed for legibility on small mobile screens, especially for users with glasses. */

export function PoliceCapIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M3 14h18" />
      <path d="M5 14v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3" />
      <path d="M5 14c0-4 3-7 7-7s7 3 7 7" />
      <circle cx="12" cy="11" r="0.8" fill="currentColor" />
      <path d="M9 10.5h6" />
    </svg>
  );
}

export function ScannerIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <rect x="3" y="4" width="18" height="6" rx="1" />
      <path d="M3 14h18" />
      <rect x="5" y="16" width="14" height="4" rx="1" />
      <path d="M7 7h2M11 7h6" />
    </svg>
  );
}

export function PhoneTriangleIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M12 2 L22 20 L2 20 Z" />
      <path d="M9 11a3 3 0 0 0 3 3 6 6 0 0 0 1.2-.2l1.4 1.4a1 1 0 0 1-.3 1.6 8 8 0 0 1-2.3.5 5 5 0 0 1-5-5 8 8 0 0 1 .5-2.3 1 1 0 0 1 1.6-.3l1.4 1.4A6 6 0 0 0 9 11Z" />
    </svg>
  );
}

export function MailTriangleIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M12 2 L22 20 L2 20 Z" />
      <rect x="7" y="11" width="10" height="7" rx="0.5" />
      <path d="M7 12 L12 16 L17 12" />
    </svg>
  );
}

export function ShieldIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M12 2L4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

export function BureauIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M3 21h18" />
      <path d="M5 21V8l7-5 7 5v13" />
      <rect x="9" y="13" width="2.5" height="3" />
      <rect x="12.5" y="13" width="2.5" height="3" />
      <path d="M9 9h6" />
    </svg>
  );
}

export function CarCrashIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M3 17h2l1-5h12l1 5h2" />
      <path d="M5 17v2h3v-2" />
      <path d="M16 17v2h3v-2" />
      <circle cx="8" cy="14.5" r="1" fill="currentColor" />
      <circle cx="16" cy="14.5" r="1" fill="currentColor" />
      <path d="M11 4l-2 3 3-1-1 3 2-2" />
    </svg>
  );
}

